import React from 'react';

const CallQuality = () => {
  return (
    <svg width='121' height='120' viewBox='0 0 121 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M48.22 31.5H25.993A4.494 4.494 0 0 0 21.5 36v63a4.5 4.5 0 0 0 4.5 4.5h33a4.5 4.5 0 0 0 4.5-4.5v-.152'
        stroke='#000'
        strokeWidth='4.4'
        strokeLinecap='round'
      />
      <circle cx='42.5' cy='94.5' r='2.5' fill='#000' />
      <path
        d='M57.5 72.043V84a4.5 4.5 0 0 0 4.5 4.5h33a4.5 4.5 0 0 0 4.5-4.5V21a4.5 4.5 0 0 0-4.5-4.5H62a4.498 4.498 0 0 0-4.5 4.497v18.765'
        stroke='#000'
        strokeWidth='4.4'
        strokeLinecap='round'
      />
      <circle cx='78.5' cy='79.5' r='2.5' fill='#000' />
      <path
        d='M43.464 66c-.414 0-.774-.153-1.08-.459a1.524 1.524 0 0 1-.432-1.08V47.829c0-.414.144-.774.432-1.08a1.478 1.478 0 0 1 1.08-.459h.729c.414 0 .774.153 1.08.459.306.306.459.666.459 1.08v6.129c0 .144.072.216.216.216h6.75c.144 0 .216-.072.216-.216v-6.129c0-.414.153-.774.459-1.08a1.478 1.478 0 0 1 1.08-.459h.729c.414 0 .765.153 1.053.459.306.306.459.666.459 1.08v16.632c0 .414-.153.774-.46 1.08a1.391 1.391 0 0 1-1.052.459h-.73c-.413 0-.773-.153-1.08-.459a1.478 1.478 0 0 1-.458-1.08v-7.155c0-.162-.072-.243-.216-.243h-6.75c-.144 0-.216.081-.216.243v7.155c0 .414-.153.774-.46 1.08a1.478 1.478 0 0 1-1.08.459h-.728zm21.252-16.578v13.446c0 .126.072.207.216.243.576.09 1.116.135 1.62.135 2.106 0 3.654-.567 4.644-1.701.99-1.152 1.485-3.042 1.485-5.67 0-2.358-.504-4.086-1.512-5.184-1.008-1.098-2.547-1.647-4.617-1.647-.504 0-1.044.045-1.62.135-.144.036-.216.117-.216.243zm-2.214 16.659a1.7 1.7 0 0 1-1.107-.567 1.79 1.79 0 0 1-.432-1.188V47.964c0-.45.144-.837.432-1.161.288-.342.657-.54 1.107-.594a35.754 35.754 0 0 1 3.86-.189c3.205 0 5.653.837 7.345 2.511 1.71 1.674 2.565 4.122 2.565 7.344 0 3.456-.855 6.057-2.565 7.803-1.692 1.728-4.14 2.592-7.344 2.592-1.422 0-2.71-.063-3.861-.189z'
        fill='var(--theme-primary, #810ea9)'
      />
    </svg>
  );
};

export default CallQuality;
